import { Component, OnInit } from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import { DataService } from '../../data.service';

@Component({
  selector: 'app-killsheet-popup',
  templateUrl: './killsheet-popup.component.html',
  styleUrls: ['./killsheet-popup.component.scss']
})
export class KillsheetPopupComponent implements OnInit {

  constructor(
    public dataSvc: DataService, 
    public translate: TranslateService) {
    if(dataSvc != null && dataSvc !== undefined){
    //   var usersLanguage = dataSvc.currentUser.Language.DotNetCulture.toString().substring(0,2);
    //   if(usersLanguage != null){
    //     translate.setDefaultLang(usersLanguage);
    //     translate.use(usersLanguage);
    //   }
    //   else{
    //     translate.setDefaultLang('en');
    //     translate.use('en');
    //   }
    // }
    // else{
      translate.setDefaultLang('en');
      translate.use('en');
    }

   }

  ngOnInit() {
  }

}
